function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: "101.7%",
  height: "104.3%",
  x: "-.8%",
  y: "-2.1%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.56555591 0 0 0 0 0.56555591 0 0 0 0 0.56555591 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#1CA6FF",
  fillRule: "evenodd",
  filter: "url(#a)",
  opacity: 0.13,
  transform: "translate(-903 -43)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  stroke: "#1CA6FF",
  strokeWidth: 3.913,
  d: "M953.737 48.173c-12.429 0-22.82 9.244-24.936 21.396-11.143 1.018-19.906 10.521-19.906 22.207 0 12.363 9.783 22.39 21.846 22.39h10.348c.368.005 1.36-1.072 1.401-2.105.053-1.299-.938-2.616-1.4-2.609H930.74c-9.594 0-17.246-7.843-17.246-17.676 0-9.834 7.652-17.677 17.246-17.677 1.19.005 2.188-.921 2.3-2.136 1.044-10.702 9.946-19.076 20.696-19.076 5.853 0 10.64 2.322 14.444 6.334a2.26 2.26 0 0 0 2.48.553c1.66-.647 4.026-.995 6.072-.995 8.26 0 15.132 6.259 16.097 14.4.1.891.684 1.648 1.509 1.951 6.57 2.472 11.139 8.952 11.139 16.646 0 9.833-7.653 17.676-17.247 17.676h-9.076c-.44-.006-1.454 1.362-1.427 2.61.023 1.106 1.037 2.11 1.427 2.104h9.076c12.063 0 21.846-10.027 21.846-22.39 0-9.095-5.26-16.867-12.9-20.365-1.77-9.906-10.32-17.345-20.444-17.345-2.084 0-4.272.352-6.324.957-4.43-4.206-10.098-6.85-16.672-6.85z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M961.14 140.147l13.232-11.133a2.118 2.118 0 0 0-1.363-3.738h-26.202a2.118 2.118 0 0 0-1.38 3.725l12.97 11.132a2.118 2.118 0 0 0 2.742.014z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M958.383 129.56h3.874a2.253 2.253 0 0 0 2.253-2.254V97.34a4.19 4.19 0 0 0-8.38 0v29.966a2.253 2.253 0 0 0 2.253 2.254z"
}));

const SvgIcBannerCloudBackup = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 105,
    viewBox: "0 0 117 105",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcBannerCloudBackup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-banner-cloud-backup.bc8bc7d3.svg";
export { ForwardRef as ReactComponent };